export const ERROR = {
  duplicateContactEmail: "Hey, contact email already captured 👀",
  duplicateListenerUsername: "Hey, RSVP for this event already captured 👀",
};
